/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginRequestOneOf1DeviceInfo
 */
export interface LoginRequestOneOf1DeviceInfo {
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    osVersion: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    appVersion: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    webviewVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    nativeVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    platform: LoginRequestOneOf1DeviceInfoPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    os?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestOneOf1DeviceInfo
     */
    appBuild?: string;
}


/**
 * @export
 */
export const LoginRequestOneOf1DeviceInfoPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    Electron: 'electron',
    Web: 'web'
} as const;
export type LoginRequestOneOf1DeviceInfoPlatformEnum = typeof LoginRequestOneOf1DeviceInfoPlatformEnum[keyof typeof LoginRequestOneOf1DeviceInfoPlatformEnum];


/**
 * Check if a given object implements the LoginRequestOneOf1DeviceInfo interface.
 */
export function instanceOfLoginRequestOneOf1DeviceInfo(value: object): value is LoginRequestOneOf1DeviceInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('osVersion' in value) || value['osVersion'] === undefined) return false;
    if (!('appVersion' in value) || value['appVersion'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function LoginRequestOneOf1DeviceInfoFromJSON(json: any): LoginRequestOneOf1DeviceInfo {
    return LoginRequestOneOf1DeviceInfoFromJSONTyped(json, false);
}

export function LoginRequestOneOf1DeviceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRequestOneOf1DeviceInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'model': json['model'],
        'osVersion': json['osVersion'],
        'appVersion': json['appVersion'],
        'webviewVersion': json['webviewVersion'] == null ? undefined : json['webviewVersion'],
        'nativeVersion': json['nativeVersion'] == null ? undefined : json['nativeVersion'],
        'platform': json['platform'],
        'os': json['os'] == null ? undefined : json['os'],
        'appBuild': json['appBuild'] == null ? undefined : json['appBuild'],
    };
}

export function LoginRequestOneOf1DeviceInfoToJSON(json: any): LoginRequestOneOf1DeviceInfo {
    return LoginRequestOneOf1DeviceInfoToJSONTyped(json, false);
}

export function LoginRequestOneOf1DeviceInfoToJSONTyped(value?: LoginRequestOneOf1DeviceInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'model': value['model'],
        'osVersion': value['osVersion'],
        'appVersion': value['appVersion'],
        'webviewVersion': value['webviewVersion'],
        'nativeVersion': value['nativeVersion'],
        'platform': value['platform'],
        'os': value['os'],
        'appBuild': value['appBuild'],
    };
}

